import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { MultipleAutocomplete } from '@src/common/components/Autocomplete';
import { TextInput } from '@src/common/components/TextInput';
import { transformToPermitStatus } from '@src/orders/domain/PermitApplication';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

export interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string[];
  options?: string[];
}

export const StatusFilter = ({ onFilterChange, value, options }: Props) => {
  const { t } = useTranslation();
  const getOptionLabel = (option: unknown) => {
    if (typeof option === 'string') {
      const permitStatus = transformToPermitStatus(option);
      return t(permitStatus.toLowerCase());
    }
    return '';
  };
  const renderInput = (params: AutocompleteRenderInputParams) => (
    <TextInput {...params} label={t('permitSearch.status')} />
  );
  const statusOptions = options?.sort();

  const selectedOptions =
    statusOptions?.filter((option) => value?.includes(option)) || [];
  return (
    <MultipleAutocomplete
      value={selectedOptions}
      onChange={(_, selectedValues: unknown) => {
        const statuses = (selectedValues as string[])?.filter(
          (val): val is string => Boolean(val),
        );
        onFilterChange({ status: statuses });
      }}
      options={statusOptions || []}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
    />
  );
};
